/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import '../../styles/components/TermsUse.scss';

const TermsUseContainer = () => {
  return (
    <div className="center-horizontal-with-margin terms-of-use--main-container">
      <div className="terms-of-use__heading">Terms Of Use</div>
      <div className="terms-of-use__heading1">1. BACKGROUND</div>
      <p className="terms-of-use__description">
        1.1 This document is an electronic record in terms Of
        <br></br>(i) Information Technology Act, 2000;
        <br></br>(ii) the rules framed there under as applicable; and
        <br></br>(iii) the amended provisions pertaining to electronic records
        in various statutes as amended by the Information Technology Act, 2000.
        This electronic record is generated by a computer system and does not require any physical
        or digital signatures.
      </p>
      <p className="terms-of-use__description">
        1.2 This document is published in accordance with the provisions of Rule 3 (1) of the Information
        Technology (Intermediaries guidelines) Rules, 2011 that requires publishing the Terms of
        Use for access or usage of the application and website made available by Vahan
        Technologies India Pvt. Ltd (collectively referred to as the “<strong>Platform</strong>”).
      </p>
      <p className="terms-of-use__description">
        1.3 The Platform is owned, registered and operated by Vahan Technologies India Pvt. Ltd, a
        company incorporated under the Companies Act, 2013 and having its registered office at
        C-625, New Friends Colony, 3 rd Floor, New Delhi – 110 025 ("<strong>Vahan</strong>" or
        <strong> "Company"</strong>).
      </p>
      <p className="terms-of-use__description">
        1.4 These terms of usage (<strong>“Terms of Use”</strong>) govern Your use of the Platform and Services (as
        defined below) provided through the Platform. By using or visiting the Platform You shall
        be deemed to have read, understood and accepted to be bound by these Terms of Use.
      </p>
      <p className="terms-of-use__description">
        1.5 For the purpose of these Terms of Use, wherever the context so requires <strong>"You", “Your”</strong> or
        <strong>“Delivery Expert”</strong> shall mean any natural or legal person who has voluntarily signed
        up/registered on the Platform to provide delivery services to identified clients of Vahan as
        notified to you ( <strong>“Customer”</strong>). The term <strong>“We”, “Us”, “Our”</strong>
        shall mean <strong>“Vahan”</strong> or the <strong>“Company”</strong>. These Terms of Use also
        include the Annexure, as notified to you from time to time, which sets out specific requirements
        or conditions for providing the Services to the notified Customer. Please ensure that you have
        read and carefully understood these Terms of Use and the Annexure.
      </p>
      <p className="terms-of-use__description">
        1.6 We reserve the right to make changes to these Terms of Use at any time. Any such modifications
        will become effective immediately upon: (i) notifying such change to You; and (ii) posting
        it on the Platform, and your continued use of the Platform constitutes your agreement to
        such modifications.
      </p>
        <div className="terms-of-use__heading1">2. SERVICES</div>
          <p className="terms-of-use__description">
            2.1 <strong>Description:</strong> Through Our Platform, the Customer shall connect directly with the Delivery
            Experts to fulfil the delivery orders placed by their customers.
          </p>
          <p className="terms-of-use__description">
            2.2 <strong>Registration:</strong> 
          </p>
            <p className="terms-of-use__description">
              2.2.1 In order to render the delivery Services, You will be first required to register on the Platform.
              You hereby grant your consent to the Company to collect, store and process Your personal
              information at the time of Your registration. Such information provided by you would be
              used in pursuance of these Terms of Use and may be shared with other third parties
              (including with the Customer, its affiliates and vendors) in furtherance of these Terms.
            </p>
            <p className="terms-of-use__description">
              2.2.2 You shall be required to submit a copy of the following documents to the Company at the time
              of Your registration: (i) Aadhar Card; (ii) Driving license; (iii) SSC/10 th standard certificate;
              (iv) Vehicle insurance; (v) Vehicle Pollution under Control (PUC) certificate; (vi) Vehicle
              No Objection Certificate issued by the Regional Transport Office (RTO); and (vii) Medical
              certificate. For the purposes of receiving the payouts, you will provide us with accurate and
              complete details of your bank account. The Company and/or the Customer is not responsible
              for non-receipt or delayed receipt of any payments from the Company on account of bank
              processing or inaccurate or incomplete details You have provided.
            </p>
            <p className="terms-of-use__description">
              2.2.3 You hereby represent to the Company that there are no criminal proceedings/cases that are
              filed against You (before any fora) as on the date of Your registration on the Platform. You
              hereby acknowledge that the Company may, through its partners conduct a background
              verification check on Your profile (from a professional standpoint and to ensure that you
              can provide the Services) before listing You on the Platform.
            </p>
            <p className="terms-of-use__description">
              2.2.4 Registration on the Platform and continued provision of Services as a Delivery Expert is
              subject to verification of personal data collected from you including copies of valid
              government-issued vehicle registration certificate, vehicle insurance copy, driving license,
              identity proof, residence proof, proof of ownership of Delivery Expert Vehicle and any other
              information that the Company may deem fit.
            </p>
            <p className="terms-of-use__description">
              2.2.5 Once listed and registered on the Platform, You will receive, on a chargeable basis (unless
              otherwise specified to You), delivery bags and T-shirts which You shall be required to
              maintain and wear at all times while performing delivery services for the Customer. You
              shall not use such bags and t-shirts for any other purpose other than delivery of orders of
              the specified Customer. In case of loss of the bags or the T-shirts, You will be required to
              purchase these afresh, for which you will be charged, and consequent deductions will be
              made from the payouts due to You. Further, You are solely responsible to maintain the
              bags and T-shirts in a clean and hygienic manner and ensure that they are adequately
              sanitized and fit for use for the Services. You are solely responsible to collect the bags and
              the T-shirts in a timely manner and as when you require the same for carrying out the
              Services hereunder.
            </p>
            <p className="terms-of-use__description">
              2.2.6 The Company shall have in place a support desk to assist You with/address any of Your queries
              pertaining to Your delivery order(s). You can reach the support desk by calling +91 80 4722
              3706, and/or emailing help@vahan.co.
            </p>
            <p className="terms-of-use__description">
              2.2.7 If so intimated to you in writing, the Company shall, at its sole discretion procure, health
              insurance coverage worth Rs. 1 lakh, to be enrolled within 7 days of on-boarding for the
              benefit of the Delivery Experts. The Delivery Partner shall, at the request of the
              Company, supply such information, and execute such documents as may be required by
              the insurance company or companies to whom the Company has applied for such
              insurance policy. You understand that these benefits are entirely discretionary and
              subject to change and withdrawal by the Company at any time and without Your consent.
              Further, and it is clarified that there is no automatic insurance coverage upon signing up
              to these Terms, and the coverage is only available to those who have received written
              communication regarding the same.
            </p>
            <p className="terms-of-use__description">
              2.2.8 In the event that You find that You are a victim of identity theft, and someone is using Your
              name/personal details, You should immediately notify us on + 91 80 4722 3706, and/or
              emailing help@vahan.co. We reserve the right to suspend any account at any time with or
              without notification to the Delivery Expert, in order to prevent any occurrence of what We
              believe to be a fraudulent activity.
            </p>
            <p className="terms-of-use__description">
              2.2.9 You agree to: (a) provide true, accurate, current and complete information about Yourself as
              required; (b) maintain and promptly update information to keep it true, accurate, current and
              complete; (c) submit any documents that may requested by the Company from time to time;
              and (c) use the Platform only to provide the Services in accordance with the terms and
              conditions stipulated herein, and such other guidelines as may be notified by
              the Company from time to time.
            </p>
          <p className="terms-of-use__description">
            2.3 <strong>Modification of Services:</strong> We reserve the right to unilaterally add,change or remove features
            and other aspects of the Services provided under these Terms of Use, including the payout
            structure, discretionary benefits, whether on account of change in circumstances, statutory
            changes or otherwise. These Terms of Use shall continue to apply to such modified
            Services, unless notified otherwise. We further reserve the right to, at any time, and from
            time to time, modify, discontinue, temporarily or permanently, the Platform or the Services
            provided, or any part thereof, with or without notice to You. It is hereby agreed by You
            that You shall not hold the Company liable for any such modification, temporary
            suspension or discontinuation of the Platform or the Services.
          </p>
          <p className="terms-of-use__description">
            2.4 <strong>Escalation:</strong>In case of any grievances, delays, or other concerns,
            You should immediately contact the support desk at +91 80 4722 3706, and/or emailing help@vahan.co.
          </p>
          <p className="terms-of-use__description">
            2.5 <strong>Contacting You:</strong> You hereby consent to be contacted on your mobile number,
            and any other electronic means, including through instant messaging systems.
          </p>
        <div className="terms-of-use__heading1">3. NATURE OF ENGAGEMENT WITH DELIVERY EXPERTS</div>
            <p className="terms-of-use__description">
              3.1 You hereby agree and acknowledge that the Platform merely facilitates You to receive delivery
              orders placed with the Customer via the Platform. You have signed up as a Delivery Expert
              on the Platform at Your own freewill and You shall render Your delivery services solely in
              Your capacity as a third - party independent contractor, on a principal to principal
              to-principal basis and the contract between the parties is a contract for service. Nothing
              mentioned herein shall create or purport to create any joint venture, employment, agency,
              franchise, fiduciary, sales representative or any vicarious and absolute liability relationship
              between the parties. Neither party shall be liable for any action or omission of the other
              party in any manner. You shall, in no event, represent yourself to be an authorized
              representative of the Company or the Customer.
            </p>
            <p className="terms-of-use__description">
              3.2 Under no circumstances shall Your performance of delivery services to the Customer via the
              Platform constitute an employer – employee relationship between: (i) Yourself and the
              Company; and/or (ii) Yourself and the Customer. Neither the Company nor the Customer
              shall be deemed to have any direct control over Your performance of delivery services.
              Under no circumstances shall the Company and/or the Customer be liable to pay You any
              statutory benefits/payments as prescribed under applicable labor laws
            </p>
            <p className="terms-of-use__description">
              3.3 You shall perform the delivery services as requested via the Platform and the performance of
              such delivery services shall not become or claim any employment or employment benefits
              or any other employment related payments from the Company and/or the Customer by virtue
              of providing the delivery services any time during the term of your engagement or
              subsequently after the termination/expiry of your engagement. The conferment of any
              equipment, safety apparatus, clothing, accessories, etc., which may be provided to You is at
              the sole discretion of the Company and/or the Customer, purely as a welfare facility and on
              humanitarian considerations, and the same along with any advertising or showcasing of the
              Customer’s brands/products/services will not in any manner be construed as an employer
              employee relationship between the parties.
            </p>

            <p className="terms-of-use__description">
              3.4 You are solely responsible to ensure the delivery of the packages handed over to you. Neither
              the Customer nor the Company exercises or purports to exercise any control over the manner
              in which you execute the Services as a Delivery Expert. You are free to undertake such
              Services in the manner you deem fit, through routes chosen by you and on vehicles owned
              or leased by you, or where you have the right to use such Vehicles.
            </p>
            <p className="terms-of-use__description">
              3.5 You shall be solely responsible to ensure that your driving license and any other mandatory
              licenses/permits and taxes are up to date, in force and paid for at all times. Failure to do may
              result in de-registration from the Platform and disbarment from providing the Services
              hereunder. All liabilities and responsibilities in relation to motor vehicle insurance,
              maintenance of the vehicle used by the Delivery Experts shall be the sole responsibility and
              at the sole cost of the Delivery Expert.
            </p>
            <p className="terms-of-use__description">
              3.6 During the duration of this arrangement, You shall act and perform the Services entirely at Your
              behest and command, in the mode and manner of Your choosing, exercising Your
              independent judgement, keeping in mind applicable laws and common sense, and the
              Company or the Customer shall have no supervision and control whatsoever over your day-
              to-day activities or the manner of provision of the Services.
            </p>
            <p className="terms-of-use__description">
              3.7 The engagement as a Delivery Expert is non-exclusive and entirely at your sole discretion and
              will, subject to satisfaction of the conditions specified in these Terms. You are free to engage
              yourself in other arrangements with other companies / parties, consulting or any other
              business activity as long as it does not create a conflict of interest with the Company’s
              business or provision of your Services as a Delivery Expert. By signing this letter, you
              confirm that you have no obligations that would prohibit you from performing your
              deliverables towards the Company.
            </p>
            <p className="terms-of-use__description">
              3.8 You acknowledge that there are no guaranteed deliveries or minimum orders made by the
              Company or the Customer.
            </p>
            <div className="terms-of-use__heading1">4. PAYMENT OF DELIVERY EXPERTS</div>
            <p className="terms-of-use__description">
              4.1 In consideration for rendering the delivery Services and unless otherwise intimated in writing,
              You shall be paid by the Company in accordance with the payout structure made available to you
              via message on whatsapp and/or over phone call, subject to deductions as set out in these Terms,
              any statutory deductions, and any deductions made on account of value added services that you
              have availed. Please visit the link above to access the current payout structure, which is subject to
              change from time to time, with due intimation to you. In case of any queries/clarifications relating
              to your payout, please contact the helpdesk at +91 80 4722 3706, and/or emailing help@vahan.co.
            </p>
            <p className="terms-of-use__description">
              4.2 You will be paid on a weekly basis and Your cycle for weekly payments shall be from Monday
              to Sunday. If You have joined mid-week, or on any day other than Monday, Your payouts
              will be pro-rated for the actual days you have rendered Services, and based on actual orders
              that have been fulfilled. Your weekly payouts will be made the following
              <br></br>
              Thursday or Friday, subject to bank delays and processing timelines.
            </p>
            <p className="terms-of-use__description">
              4.3. The Company will deduct amounts towards the cost of the bags and uniforms provided to
              You, unless otherwise specified.
            </p>
            <p className="terms-of-use__description">
              4.4 The abovementioned payout structure, payout cycle and deductions are solely determined by the
              Customer and the same may be subject to revision at the sole discretion of the Customer
              and/or the Company at any point in time. Any other variable pay or non-cash consideration
              for the Services will solely be provided by the Customer, if so decided, at its sole discretion.
            </p>
            <p className="terms-of-use__description">
              4.5 Notwithstanding anything contained herein, the Customer may directly make payouts or
              payments to You, in which case, the Company would not be responsible or liable for any
              payments to You.
            </p>
            <p className="terms-of-use__description">
              4.6 EXCEPT FOR THE ABOVE, NEITHER THE CUSTOMER NOR THE COMPANY
              SHALL BE LIABLE FOR ANY OTHER PAYMENTS OR FEES, WHETHER UNDER
              LAW OR CONTRACT, IN RELATION TO THE SERVICES PROVIDED BY THE
              DELIVERY EXPERT.
            </p>

            <div className="terms-of-use__heading1">
              5. GUIDELINES TO BE FOLLOWED BY DELIVERY EXPERTS
            </div>
            <p className="terms-of-use__description">
              5.1 The Delivery Experts shall at all times while rendering delivery services:
            </p>
            <p className="terms-of-use__description">
              (i) strictly adhere to any policies/guidelines prescribed by the Company or the Customer, from
              time to time;
            </p>
            <p className="terms-of-use__description">
              (ii) behave and exhibit conduct in a manner that is appropriate and becoming of a delivery
              expert;
            </p>
            <p className="terms-of-use__description">
              (iii) conduct himself/herself with honesty, discipline and in accordance with applicable laws
              including but not limited to safe driving;
            </p>
            <p className="terms-of-use__description">
              (iv) at no time whatsoever, tamper with, damage, open or do anything to the packages being
              delivered by the Delivery Expert;
            </p>
            <p className="terms-of-use__description">
              (v) contact the designated personnel of the Company and/or the Customer in the event the
              Delivery Expert encounters any issue while performing their Services;
            </p>
            <p className="terms-of-use__description">
              (vi) not consume any tobacco products or alcohol or any other illegal substance or solicit the
              use of such substance while rendering delivery services;
            </p>
            <p className="terms-of-use__description">
              (vii) strictly adhere to the provisions of the Motor Vehicles Act, 1988 and its corresponding
              rules and also the traffic rules while performing the delivery services;
            </p>
            <p className="terms-of-use__description">
              (viii) maintain the delivery bag, uniform and any other materials received from the Company
              or the Customer in good condition and not misuse the same in any way;
            </p>
            <p className="terms-of-use__description">
              (ix) shall not engage in conduct, in any way, that would amount to harassment, sexual
              harassment, bullying, or engage in violence. The Company and the Customer have zero
              tolerance for any such conduct and the engagement of the Delivery Expert will be
              terminated immediately, if found to be engaging in such misconduct;
            </p>
            <p className="terms-of-use__description">
              (x) shall not engage in any abusive behavior towards any personnel of the Company or the
              Customer or any end-customer/user of the Customer or subject such person(s) to any kind
              of harassment or use obscenities while communicating with such person(s).
            </p>
            <div className="terms-of-use__heading1">6. LIMITATIONS AND DISCLAIMER OF WARRANTY</div>
            <p className="terms-of-use__description">
              6.1 The Platform, the Services and each portion thereof are provided "as is" without warranties of
              any kind either express or implied. To the fullest extent possible pursuant to applicable laws
              of India, we disclaim all warranties, express or implied, with respect to the Platform and
              each portion thereof, including, but not limited to, implied warranties of merchantability,
              fitness for a particular purpose, non-infringement or other violation of rights.
            </p>
            <p className="terms-of-use__description">
              6.2 Under no circumstances, including, but not limited to, negligence, shall We be liable for any
              direct, indirect, special, incidental or consequential damages, including, but not limited to,
              loss of data or profit, arising out of the use, or the inability to use the Platform or any portion
              thereof, even if We or Our authorized representative has been advised of the possibility of
              such damages.
            </p>
          <div className="terms-of-use__heading1">7. INDEMNIFICATION</div>
            <p className="terms-of-use__description">
              You agree to indemnify, defend and hold harmless the Customer and the Company, and
              their respective affiliates, officers, directors, agents, partners, employees, licensors,
              representatives and third party service providers or vendors, from and against all losses,
              expenses, damages, costs, claims and demands, including reasonable attorney's fees and
              related costs and expenses, due to or arising out of any unauthorized use of the Platform,
              or Your connection to the Services, or Your breach of these Terms of Use. We reserve the
              right, at our own expense to assume the exclusive defense and control of any matter
              otherwise subject to indemnification by You, and in such case, You agree to fully cooperate
              with such defense and in asserting any available defenses. <strong>In particular, if the Company
              and/or the Customer suffers any loss due to the Delivery Expert tampering with,
              damaging or opening the packaging of food and beverages orders, the Company
              and/or the Customer shall be entitled to recover the loss, if any, from the payments
              due to the Delivery Expert, or through any other means, without prejudice to any other
              remedies.</strong>
            </p>

          <div className="terms-of-use__heading1">8.TERMINATION</div>
          <p className="terms-of-use__description">
            8.1 We may terminate these Terms of Use immediately without notice in the event of (i) any breach
            by You of these Terms of Use or any of our applicable policies, as may be intimated to You
            from time to time, or (ii) it is discovered or comes to our notice or the notice of the Customer
            that any information given in your application, declaration or any document is false or you
            have misrepresented or omitted to provide relevant information.
          </p>
          <p className="terms-of-use__description">
            8.2 Without prejudice to the above, we may terminate these Terms of Use without notice to You
            by terminating your rights to use the Platform or the Services for any reason or no reason.
            In the event of termination or expiration of these Terms of Use, the following sections of
            these Terms of Use shall survive: (i) all provisions regarding ownership of intellectual
            property rights; (ii) indemnification; (iii) disclaimer of warranties; and (iv) limitations of
            liability; (v) consequences of improper conduct, fraud or abuse, and the provisions of this
            section.
          </p>
          <p className="terms-of-use__description">
            8.3 Your final settlement shall be processed in the following weekly payment cycle, except in
            cases where the Client is responsible for directly making payments to you, in which case, the
            Client will be responsible for the final settlement in accordance with their policies and procedures.
          </p>
          <p className="terms-of-use__description">
            8.4 You agree that upon the termination of these Terms of Use, We may delete all information
            related to You on the Services and may bar Your access to the Platform and use of the
            Services, if the situation so warrants.
          </p>
        <div className="terms-of-use__heading1">9. VALUE ADDED SERVICES</div>
          <p className="terms-of-use__description">
            9.1 At its sole discretion, the Company facilitates the below value added services to You that are
            provided by third parties, which you are free to avail, at your sole risk and based on your
            sole decision. The Company reserves the right to unilaterally modify or withdraw all or any
            of the services now or in future, with due intimation to You. You understand and agree that
            these services are only facilitated by the Company and are not provided by the Company,
            but by the other third party service providers directly to You. The Company bears no liability
            and bears no responsibility in relation to these services, the quality of or deficiency in such
            services, and any complaints/grievances in relation to the same will have to be directly raised
            with the relevant service provider. The Company does not determine or assess the eligibility
            criteria or other conditions attached to availing these services, and
            the relevant service provider, at its sole discretion, may determine not to provide the
            particular service to You. In such a case, You understand and agree that the Company bears
            no liability arising out of such decisions.
          </p>
          <p className="terms-of-use__description">
            9.2 If you wish to avail any of these services, please inform +91 80 4722 3706. You can opt in for
            these services at any time during the term of this arrangement. Once You opt in, the agreed
            amounts will be deducted from your payouts due to You under these Terms. You hereby
            authorize the Company to deduct such amounts from any amounts due to you. You further
            understand and grant your consent to the Company to collect, store and process Your
            personal information which you have provided to the Company in the course of registration
            on the Platform or at any time thereafter. Such information (including your identity and
            address information and documents attesting to the same) provided by you would be used
            in order to process the value added services that you have opted to avail, and will be shared
            with third parties, such as the lenders, insurers, credit agencies, etc. in furtherance thereof.
          </p>
          <p className="terms-of-use__description">
            9.3 If you decide to opt out of a service in future, You will be responsible to ensure that your decision
            to do so is communicated to the relevant service provider. We will deduct such amounts
            from Your payouts, as communicated to us by the relevant service providers.
          </p>
          <p className="terms-of-use__description">
            9.4 Upon termination of your engagement as a Delivery Expert, or termination of these Terms, you
            will be solely liable to settle all dues of the service provider, on account of the value added
            services.
          </p>
          <p className="terms-of-use__description">
            9.5 The value added services are:
            <li> Salary advances</li>
            <li> Micro loans</li>
            <li> Accidental insurance</li>
            <li> Telemedicine</li>
            <li> Hospicash benefits</li>
            <li> Health insurance plan</li>
          </p>
        <div className="terms-of-use__heading1">10. GENERAL</div>
          <p className="terms-of-use__description">
            Unless otherwise specified herein, this Terms of Use for Services constitutes the entire
            agreement between You and the Company in respect of the Services and supersedes all
            previous written and oral agreements between you and the Company, if any. The Company’s
            failure to act with respect to a breach committed by You or others does not waive its right
            to act with respect to subsequent or similar breaches.
          </p>

        <div className="terms-of-use__heading1">11. CONFIDENTIALITY</div>
          <p className="terms-of-use__description">
              You agree to safeguard any confidential information of the Customer or the
              Company, which You may have had access to during the provision of Services, and to
              prevent the unauthorized, negligent or inadvertent use or disclosure thereof. You will not,
              without Our prior written approval, directly or indirectly, use or disclose such confidential
              information to any person or business.
          </p>
        <div className="terms-of-use__heading1">12. GOVERNING LAW </div>
          <p className="terms-of-use__description">
            This Terms of Use document shall be governed by and constructed in
            accordance with the applicable laws of India without reference to conflict of laws principles.
            Any disputes arising in relation to, or under, this Terms of Use and the Privacy Policy, shall
            be subject to the exclusive jurisdiction of the courts of New Delhi.
          </p>
        <div className="terms-of-use__heading1">13. GRIEVANCE OFFICER</div>
          <p className="terms-of-use__description">
            In accordance with Information Technology Act 2000 and rules made
            there under, the name and contact details of the Grievance Officer are provided below:
            <blockquote className="terms-of-use__blockquote">
            <p>Name: Abhishek Chaturvedi</p>
            <p>Email: help@vahan.co</p>
            </blockquote>
          </p>
    </div>
  );
};

export default TermsUseContainer;
